import type { MusinsaStandardResponse } from '@musinsa/packages-http';
import { executeStandardRequest, querify } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import { z } from 'zod';
import { publicHttpClient } from '../httpClient';
import { linkApiPath } from './apiPath';

const GetLinkCurationRequestParamsSchema = z
  .object({
    curationId: z.string().optional(),
  })
  .describe('GetLinkCurationRequestParamsSchema');

type GetLinkCurationRequestParams = z.infer<typeof GetLinkCurationRequestParamsSchema>;

const GetLinkCurationResponseDataSchema = z
  .object({
    shortLink: z.string(),
  })
  .describe('GetLinkCurationResponseDataSchema');

type GetLinkCurationResponseData = z.infer<typeof GetLinkCurationResponseDataSchema>;

type GetLinkCurationResponse = MusinsaStandardResponse<GetLinkCurationResponseData>;

export const getLinkCuration = (params: GetLinkCurationRequestParams) =>
  executeStandardRequest(() =>
    publicHttpClient.get<GetLinkCurationResponse>(
      urlJoin(linkApiPath.getLinkCuration, querify(params)),
    ),
  );
